import { useEffect, useRef } from "react";
import { useQuery } from "@tanstack/react-query";
import { trpc } from "../../lib/trpc.js";

const COLD_START_HINT_MS = 3000;

type SessionData = { id: string; email: string; displayName: string } | undefined;

export function useSession(): ReturnType<typeof useQuery<SessionData>> {
  return trpc.auth.me.useQuery(undefined, { retry: false }) as ReturnType<typeof useQuery<SessionData>>;
}

export function useColdStartToast(
  isLoading: boolean,
  onShow: () => void,
  onHide: () => void,
) {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (isLoading) {
      timerRef.current = setTimeout(onShow, COLD_START_HINT_MS);
    } else {
      if (timerRef.current) clearTimeout(timerRef.current);
      onHide();
    }
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [isLoading, onShow, onHide]);
}
